import React from 'react';
// icon dropdown of the page
import sortCaret from 'components/Table/Others/sortCaret';
import IconDropdown from 'components/Dropdown/IconDropdown';
import { viewMobile } from 'utils/number';
import { CgDetailsMore } from 'react-icons/cg';
import { MdOutlineBlock, MdOutlineRefresh } from 'react-icons/md';
// import GenderIcon from 'components/icons/GenderIcon';
import mixpanel from 'assets/img/mixpanel.png';
import ProgressBar from 'components/Progress/ProgressBar';
// helpers
import { Link , IconButton, HStack } from '@chakra-ui/react';
import { viewDateAndTime } from 'utils/date';
import { getGenderView } from 'utils';
import { viewFullName } from 'utils/name';

export const getConsumerTableHeader = ({ items, onViewUser, onClickSuspend, suspendState }) => {
    return [
        {
            text: 'Name',
            dataField: 'FirstName',
            headerStyle: ()=>{
                return { width: '150px ' };
            },

            formatter: (cell, row, rowIndex, formatExtraData) => {
                return viewFullName(row);
            }
        },
        {
            text: 'Email',
            dataField: 'ContactPointEmailValue',
            headerStyle: ()=>{
                return { width: '100px ' };
            },
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return (
                    <React.Fragment>
                        <Link color='brand.500' href={'mailto:' + cell}>
                            {cell}
                        </Link>
                    </React.Fragment>
                );
            }

        },
        {
            text: 'Gender',
            dataField: 'gender',
            headerStyle: ()=>{
                return { width: '80px ' };
            },
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return getGenderView(cell);
            }

        },
        {
            text: 'Joined On',
            dataField: 'createdAt',
            headerStyle: ()=>{
                return { width: '180px ' };
            },

            formatter: (cell, row, rowIndex, formatExtraData) => {
                return viewDateAndTime(cell);
            }
        },
        {
            text: 'Profile Completion',
            dataField: 'profilePercentage',
            headerStyle: ()=>{
                return { width: '150px ' };
            },
            formatter: (cell)=>{
                return (
                    <>
                        <ProgressBar value={cell.toString()}/>
                    </>
                );
            }
        },
        {
            text: 'Transactions',
            dataField: 'txtcount',
            headerStyle: ()=>{
                return { width: '100px ' };
            },

            formatter: (cell, row) => {
                return (
                    <Link variant={'button'} href={'#'} color='brand.500'>
                        {cell}
                    </Link>
                );
            }
        },
        {
            text: 'Action',
            dataField: '_id',
            headerStyle: ()=>{
                return { width: '120px ' };
            },
            formatter: (cell, row) => {
                let item = (row?.isSuspendedByAdmin || suspendState?._id === 'SUSPEND')
                    ? {
                        label: 'Unsuspend User',
                        color: 'green.500',
                        disabled: false,
                        icon: <MdOutlineRefresh/>,
                        handleClick: onClickSuspend
                    }
                    : {
                        label: 'Suspend User',
                        color: 'red.500',
                        disabled: false,
                        icon: <MdOutlineBlock/>,
                        handleClick: onClickSuspend
                    };

                return (
                    <HStack width={'7rem'}>
                        <IconButton
                            aria-label="View on Mixpanel"
                            icon={<img src={mixpanel} alt="Mixpanel" style={{ width: '1.5rem', height: '1.5rem' }} />}
                            variant="ghost"
                            onClick={() => window.open(`https://mixpanel.com/project/3702032/view/4200228/app/profile#distinct_id=${cell}`, '_blank', 'noreferrer')}
                        />
                        <IconDropdown items={[...items, item]} data={row} />
                        <IconButton
                            aria-label="View on Mixpanel"
                            icon={<CgDetailsMore/>}
                            variant="ghost"
                            onClick={()=> onViewUser(row)}
                        />
                    </HStack>
                );
            }
        }

    ];
};

export const getUsersTableHeader = () => {
    return [
        {
            text: 'Email',
            dataField: 'ContactPointEmailValue',
            sort: true,
            sortCaret,
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return (
                    <Link href={'/organization/user/consumer/' + row._id} color='brand.500'>
                        {cell}
                    </Link>
                );
            }
        },
        {
            text: 'First Name',
            dataField: 'FirstName',
            sort: true,
            sortCaret
        },
        {
            text: 'Last Name',
            dataField: 'LastName',
            sort: true,
            sortCaret
        },
        {
            text: 'Gender',
            dataField: 'gender',
            sort: true,
            sortCaret
        },
        {
            text: 'Mobile No',
            dataField: 'ContactPointTelephonePrefix',
            formatter: (value, row)=>{
                return viewMobile(row);
            },
            sortCaret,
            sort: true

        },
        {
            text: 'Created At',
            dataField: 'createdAt',
            sort: true,
            sortCaret,
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return viewDateAndTime(cell);
            }
        },
        {
            text: 'Action',
            dataField: '_id',
            sort: true,
            sortCaret,
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return (
                    <Link href={'/organization/user/lender/user/' + cell} color='brand.500'>
                    View Details
                    </Link>
                );
            }
        }

    ];
};
